import { Component, HostBinding, Input } from '@angular/core';

type CardIndicatorColor = 'primary' | 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'contrast';
type CardIndicatorsSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

@Component({
  selector: 'app-card-indicators',
  templateUrl: './card-indicators.component.html',
  styleUrls: ['./card-indicators.component.scss'],
  standalone: true,
})
export class CardIndicatorsComponent {
  @Input() color: CardIndicatorColor = 'primary';
  @Input() size: CardIndicatorsSize = 'sm';

  @HostBinding('class.card-indicators') readonly isCardIndicators = true;

  // sizes
  @HostBinding('class.card-indicators--xs') get isXs() {
    return this.size === 'xs';
  }
  @HostBinding('class.card-indicators--sm') get isSm() {
    return this.size === 'sm';
  }
  @HostBinding('class.card-indicators--md') get isMd() {
    return this.size === 'md';
  }
  @HostBinding('class.card-indicators--lg') get isLg() {
    return this.size === 'lg';
  }
  @HostBinding('class.card-indicators--xl') get isXl() {
    return this.size === 'xl';
  }

  // colors
  @HostBinding('class.card-indicators--primary') get isPrimary() {
    return this.color === 'primary';
  }

  @HostBinding('class.card-indicators--success') get isSuccess() {
    return this.color === 'success';
  }

  @HostBinding('class.card-indicators--warning') get isWarning() {
    return this.color === 'warning';
  }

  @HostBinding('class.card-indicators--danger') get isDanger() {
    return this.color === 'danger';
  }

  @HostBinding('class.card-indicators--info') get isInfo() {
    return this.color === 'info';
  }

  @HostBinding('class.card-indicators--neutral') get isNeutral() {
    return this.color === 'neutral';
  }

  @HostBinding('class.card-indicators--contrast') get isContrast() {
    return this.color === 'contrast';
  }
}
